<template>
  <div class="settingPage common-style">
    <a-tabs tabPosition="left" defaultActiveKey="1">
      <a-tab-pane key="1">
        <span slot="tab">基本设置</span>
        <div class="basic-box content-box">
          <div class="title">基本设置</div>

          <a-form :form="form" @submit.prevent="updateInfo" id="add">
            <div class="form-left">
              <a-form-item label="姓名" v-bind="formItemLayout">
                <a-input
                  placeholder="请输入真实姓名"
                  v-decorator="[
          'fullname',
          {rules: [{ required: true, message: '请输入姓名' }],initialValue: userList.fullName}
        ]"
                />
              </a-form-item>
              <a-form-item label="性别" v-bind="formItemLayout">
                <a-radio-group
                  v-decorator="['gender',{rules: [{ required: true}],initialValue: userList.gender}]"
                >
                  <a-radio :value="0">男</a-radio>
                  <a-radio :value="1">女</a-radio>
                </a-radio-group>
              </a-form-item>
              <a-form-item label="邮箱" v-bind="formItemLayout">
                <a-input
                  placeholder="请输入邮箱"
                  v-decorator="[
          'email',
          {rules: [{ required: true, message: '请输入邮箱',pattern:/\w+([-+.]\w+)*@\w+([-.]\w+)*\.\w+([-.]\w+)*/ }],initialValue: userList.email}
        ]"
                />
              </a-form-item>
              <!-- <a-form-item label="昵称" v-bind="formItemLayout">
                                <a-input placeholder="请输入用户昵称" v-decorator="[
          'nickname',
          {rules: [{ required: true, message: '请输入昵称' }],initialValue: userList.nickName}
        ]" />
              </a-form-item>-->
              <a-form-item label="联系电话" v-bind="formItemLayout">
                <a-input
                  placeholder="请输入联系电话"
                  v-decorator="[
          'mobile',
          {rules: [{ required: true, message: '请输入联系电话' }],initialValue: userList.mobile}
        ]"
                />
              </a-form-item>
              <a-form-item label="个人简历" v-bind="formItemLayout">
                <a-textarea
                  placeholder="这个人很懒，什么都没留下"
                  :rows="4"
                  v-decorator="[
          'vitae',
          {rules: [{ message: '请输入您的个人简历' }]}
        ]"
                />
              </a-form-item>
              <a-form-item :wrapper-col="{ span: 12, offset: 4 }">
                <a-button type="primary" html-type="submit">更新信息</a-button>
              </a-form-item>
            </div>
            <div class="form-right">
              <div class="photo">
                <a-form-item>
                  <!-- <p style="color:#F56C6C; font-weight:bold; margin-top:10px;">张三</p> -->
                  <div class="pic">
                    <img :src="imageUrl" />
                  </div>
                  <a-upload
                    name="avatar"
                    :data="obj"
                    :action="upload.root + 'v1/learnonly/personInfo/upload'"
                    :headers="upload.headers"
                    :showUploadList="false"
                    @change="handleChange"
                  >
                    <a-button size="small">
                      <a-icon type="upload" />更换头像
                    </a-button>
                  </a-upload>
                </a-form-item>
              </div>
            </div>
          </a-form>
        </div>
      </a-tab-pane>
      <a-tab-pane key="2">
        <span slot="tab">安全设置</span>
        <div class="security-box content-box">
          <div class="title">安全设置</div>

          <a-list class="demo-loadmore-list" itemLayout="horizontal">
            <a-list-item>
              <a slot="actions" @click="editPassword">修改密码</a>
              <a-list-item-meta>
                <p class="stitle" slot="title">*********</p>
              </a-list-item-meta>
            </a-list-item>
          </a-list>
        </div>
      </a-tab-pane>
      <a-tab-pane key="3">
        <span slot="tab">微信绑定</span>
        <div class="security-box content-box">
          <div class="title">微信绑定</div>

          <a-list class="demo-loadmore-list" itemLayout="horizontal">
            <a-list-item v-if="weixinBindInfo.nickName.length==0">
              <a slot="actions" @click="toBindWeixin">扫码绑定</a>
              <a-list-item-meta>
                <p class="stitle" slot="title">您当前还没有绑定微信账号，第一次使用微信扫码登录时即可完成绑定</p>
              </a-list-item-meta>
            </a-list-item>
            <a-list-item v-if="weixinBindInfo.nickName.length>0">
              <a slot="actions" @click="deleteWeixinBind">解除绑定</a>
              <a-list-item-meta>
                <p class="stitle" slot="title">
                  <img :src="weixinBindInfo.headImgUrl" width="30" />
                  {{weixinBindInfo.nickName}}
                  （已于{{weixinBindInfo.createtime}}绑定）
                </p>
              </a-list-item-meta>
            </a-list-item>
          </a-list>
        </div>
      </a-tab-pane>

      <a-tab-pane key="4">
        <span slot="tab">钉钉绑定</span>
        <div class="security-box content-box">
          <div class="title">钉钉绑定</div>

          <a-list class="demo-loadmore-list" itemLayout="horizontal">
            <a-list-item v-if="dingdingBindInfo.nickName.length==0">
              <a slot="actions" @click="toBindDingding">扫码绑定</a>
              <a-list-item-meta>
                <p class="stitle" slot="title">您当前还没有绑定钉钉账号，第一次使用钉钉扫码登录时即可完成绑定</p>
              </a-list-item-meta>
            </a-list-item>
            <a-list-item v-if="dingdingBindInfo.nickName.length>0">
              <a slot="actions" @click="deleteDingdingBind">解除绑定</a>
              <a-list-item-meta>
                <p class="stitle" slot="title">
                  <img :src="dingdingBindInfo.headImgUrl" width="30" />
                  {{dingdingBindInfo.nickName}}
                  （已于{{dingdingBindInfo.createtime}}绑定）
                </p>
              </a-list-item-meta>
            </a-list-item>
          </a-list>
        </div>
      </a-tab-pane>
    </a-tabs>

    <!-- 弹框 -->
    <a-modal title="重置密码" v-model="visible" cancelText="取消" okText="确认" @ok="edit" @cancel="del">
      <a-form layout="inline" :form="passForm">
        <a-form-item label="新 密 码：">
          <a-input
            type="password"
            placeholder="请输入新密码"
            style="width: 300px"
            v-decorator="[
          'pwd',
          {rules: [{ required: true, message: '请输入新密码!'}]}
        ]"
          />
        </a-form-item>
        <a-form-item label="确认密码：">
          <a-input
            type="password"
            placeholder="请再次输入密码"
            style="width: 300px"
            v-decorator="[
          'npwd',
          {rules: [{ required: true, message: '请再次输入密码!'}]}
        ]"
          />
        </a-form-item>
      </a-form>
    </a-modal>
  </div>
</template>

<script>
// import { constants } from "crypto";
// import { log } from "util";
import weixinicon from "@/assets/images/weixinicon.png"
import dingdingicon from "@/assets/images/dingdingicon.png"
function getBase64 (img, callback) {
  // const reader = new FormData();
  // reader.append("userid", 20019);
  // console.log('======================');
  // console.log(reader.get('userid'));
  // reader.onload = function() {
  //   console.log('----------------');
  //   console.log(reader.result);
  //   callback(reader.result)
  // }
  const reader = new FileReader();
  reader.addEventListener("load", () => callback(reader.result));
  reader.readAsDataURL(img);
}
export default {
  inject: ['reload'],
  data () {
    return {
      formItemLayout: {
        labelCol: { span: 5 },
        wrapperCol: { span: 18 }
      },
      securityData: [],
      form: this.$form.createForm(this),
      userList: {},
      visible: false,
      passForm: this.$form.createForm(this),
      imageUrl: '',
      upload: {
        root: process.env.VUE_APP_BASE_API,
        headers: { authorization: this.$store.getters.token }
      },
      uploadFormData: {
        cover: ""
      },
      coverUrl: "",
      obj: {
        userid: this.$store.getters.id
      },
      weixinBindInfo: { nickName: "", headImgUrl: "", openid: "", createtime: "" },
      dingdingBindInfo: { nickName: "", headImgUrl: "", openid: "", createtime: "" },
      loading: false,
    };
  },
  methods: {
    //获取个人信息
    async getUserInfo () {
      const res = await this.$http.get(
        "v1/learnonly/personInfo/getPersonInfo?userid=" + this.$store.getters.id
      );
      if (res.status == 200) {
        this.userList = res.data;
        this.imageUrl = res.data.avatar

        if (this.userList.thirdInfoList && this.userList.thirdInfoList.length > 0) {
          this.userList.thirdInfoList.forEach(ele => {
            if (ele.source == 1) {//已绑的微信账号
              let nickName = (ele.nickName && ele.nickName.length > 0) ? ele.nickName : "微信用户" + ele.openid
              this.weixinBindInfo.nickName = this.htmlEncode(nickName)
              this.weixinBindInfo.openid = ele.openid

              this.weixinBindInfo.headImgUrl = (ele.headImgUrl) ? ele.headImgUrl : weixinicon
              this.weixinBindInfo.createtime = ele.createtime.replace("T", " ")
            }
            if (ele.source == 2) {//已绑的钉钉账号
              let nickName = (ele.nickName && ele.nickName.length > 0) ? ele.nickName : "钉钉用户" + ele.openid
              this.dingdingBindInfo.nickName = this.htmlEncode(nickName)
              this.dingdingBindInfo.openid = ele.openid

              this.dingdingBindInfo.headImgUrl = (ele.headImgUrl) ? ele.headImgUrl : dingdingicon
              this.dingdingBindInfo.createtime = ele.createtime.replace("T", " ")
            }
          });

        }
      }
    },

    htmlEncode (str) {
      return $("<div/>").text(str).html()
    },


    //更新个人信息
    updateInfo () {
      this.form.validateFields(async (err, values) => {
        values.userid = this.$store.getters.id;
        if (!err) {
          const res = await this.$http.post(
            "v1/learnonly/personInfo/updatePersonInfo",
            values
          );
          // console.log(res);
          if (res.data != "修改成功") {
            this.$message.warning(res.data);
          } else {
            this.$message.success(res.data);
          }
          this.form.resetFields();
          this.getUserInfo();
        }
      });
    },

    editPassword () {
      this.visible = true;
    },
    //弹框消失清除表单内容
    del () {
      this.visible = false;
      this.passForm.resetFields();
    },

    // 更改密码
    edit () {
      this.passForm.validateFields(async (err, values) => {
        if (values.pwd != values.npwd) {
          this.$message.error("密码不一致,请重新输入");
          return this.passForm.resetFields();
        }
        const res = await this.$http.post("v1/learnonly/personInfo/updatePersonInfo", {
          password: values.npwd,
          userid: this.$store.getters.id
        });
        // console.log(res);
        if (res.status == 200) {
          this.$message.success(res.data);
          this.passForm.resetFields();
          this.visible = false;
        }
      });
    },

    //上传头像
    handleChange (info) {
      if (info.file.status === "uploading") return;
      if (info.file.status === "done") {
        getBase64(info.file.originFileObj, imageUrl => {
          this.imageUrl = imageUrl;
          this.uploadFormData = {
            cover: this.imageUrl
          };
          // localStorage.setItem('imgUrl', info.file.response.accessFilePath)
        });
        this.reload()
      }
    },

    logout () {
      this.$store.dispatch("logout").then(() => {
        this.$router.push({ path: "/login" })
      })
    },

    //添加微信绑定
    toBindWeixin () {
      let that = this
      this.$confirm({
        title: "是否退出到登录页面，使用微信扫一扫二维码完成账号绑定?",
        okText: "确认",
        okType: "danger",
        cancelText: "取消",
        onOk () {
          sessionStorage.setItem("logintype", "weixin")
          that.logout()
        }
      })
    },




    //添加钉钉绑定
    toBindDingding () {
      let that = this
      this.$confirm({
        title: "是否退出到登录页面，使用钉钉扫一扫二维码完成账号绑定?",
        okText: "确认",
        okType: "danger",
        cancelText: "取消",
        onOk () {
          sessionStorage.setItem("logintype", "dingding")
          that.logout()
        }
      })
    },


    //删除微信绑定
    deleteWeixinBind () {
      var that = this
      this.$confirm({
        title: "确认要解除已绑定的 微信账号 吗?",
        okText: "确认",
        okType: "danger",
        cancelText: "取消",
        onOk () {
          clearTimeout(that.debounceTimer1)
          that.debounceTimer1 = setTimeout(() => {
            that.__deleteBindedOpenid("weixin")
          }, 300)
        }
      })
    },

    //删除钉钉的账号绑定
    deleteDingdingBind () {
      var that = this
      this.$confirm({
        title: "确认要解除已绑定的 钉钉账号 吗?",
        okText: "确认",
        okType: "danger",
        cancelText: "取消",
        onOk () {
          clearTimeout(that.debounceTimer2)
          that.debounceTimer2 = setTimeout(() => {
            that.__deleteBindedOpenid("dingding")
          }, 300)
        }
      })
    },


    __deleteBindedOpenid (state) {
      if (this.loading == true) return
      this.loading = true
      this.$http
        .post("v1/user/login/" + state + "/deletebindingopenid", {
          userid: this.$store.getters.id,
        })
        .then((response) => {
          this.loading = false
          if (response.status == 200 && response.data.code == 200) {//绑定成功
            window.location.reload()
          } else {
            this.$message.error(response.data.message)
          }
        })
        .catch((error) => {
          this.loading = false
          this.$message.error("网络或服务器错误" + error)
        })
    },



  },
  created () {
    this.getUserInfo();
  }
};
</script>

<style scoped>
.settingPage .content-box .title {
  font-size: 18px;
  color: #333;
  font-weight: bold;
  padding-top: 10px;
}
.settingPage .basic-box .form-left {
  width: 55%;
  height: auto;
  float: left;
  padding: 10px 0px;
}
.settingPage .basic-box .form-right {
  width: 35%;
  height: auto;
  float: right;
  padding: 50px 20px;
}
.settingPage .basic-box .form-right .photo {
  text-align: center;
}
.settingPage .basic-box .form-right .photo .pic {
  width: 143px;
  height: 143px;
  display: block;
  border-radius: 50%;
  overflow: hidden;
  margin: 10px auto 20px;
  background: #ccc;
}
.settingPage .basic-box .form-right .photo .pic img {
  width: 143px;
  height: 143px;
}
.settingPage .security-box .demo-loadmore-list {
  margin-top: 20px;
  margin-right: 40px;
  border-bottom: 1px solid #e5e5e5;
}
.settingPage .security-box .demo-loadmore-list p.stitle {
  font-size: 15px;
  color: #333;
}

.ant-layout-content {
  height: 540px !important;
}

.ant-row {
  margin-bottom: 20px;
}
</style>